export const timerBoxTheme = {
  bg: 'palette.surface.5',
  borderColor: 'palette.tertiary.20',
  borderRadius: '5px',
  borderWidth: '1px',
  pinIcon: 'palette.success.40',
  time: 'palette.neutral.90',
  zone: 'palette.neutral.50',
};
